import { render, staticRenderFns } from "./cenInvite.vue?vue&type=template&id=36dba74a&scoped=true&"
import script from "./cenInvite.vue?vue&type=script&lang=js&"
export * from "./cenInvite.vue?vue&type=script&lang=js&"
import style0 from "./cenInvite.vue?vue&type=style&index=0&id=36dba74a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dba74a",
  null
  
)

export default component.exports